var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.90661 11.3492C5.99212 11.2495 6.09644 11.1675 6.21363 11.1081C6.33081 11.0487 6.45856 11.0129 6.58957 11.0029C6.72058 10.9929 6.85228 11.0088 6.97714 11.0497C7.10201 11.0906 7.21759 11.1557 7.31728 11.2412L15.9999 18.6826L24.6826 11.2412C24.885 11.0788 25.1427 11.0013 25.4012 11.0254C25.6597 11.0494 25.8987 11.173 26.0677 11.3701C26.2367 11.5671 26.3224 11.8222 26.3068 12.0813C26.2912 12.3404 26.1754 12.5833 25.9839 12.7586L16.6506 20.7586C16.4694 20.9139 16.2386 20.9992 15.9999 20.9992C15.7613 20.9992 15.5305 20.9139 15.3493 20.7586L6.01595 12.7586C5.81486 12.5859 5.69053 12.3405 5.67028 12.0763C5.65003 11.812 5.73552 11.5505 5.90795 11.3492","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
